<template>
  <div class="text-static-default-hi pb-56">
    <Main :comparisonData :comparisonPending />
  </div>
</template>

<script lang="ts" setup>
import { definePageMeta } from '#imports'

import Main from '../../components/Results/Main/Main.vue'
import { useFetchResultsPage } from '../../composables/useFetchResultsPage/useFetchResultsPage'
import { useStickyRouteParam } from '../../composables/useStickyRouteParam'

definePageMeta({ scrollToTop: false })

const model1 = useStickyRouteParam('productA')
const model2 = useStickyRouteParam('productB')

const { data: comparisonData, pending: comparisonPending } =
  await useFetchResultsPage(model1, model2)
</script>
